jQuery(function($) {
  "use strict";

  // Animate hero text on load
  if ($(".hero__inner").length) {
    $(".hero__inner h1, .hero__inner p, .hero__inner .buttons__wrapper").each(function(index) {
      var $this = $(this);
      setTimeout(function() {
        $this.addClass("animate");
      }, index * 200);
    });
  }

  if (
    $(".hero__slider.has-multiple").length &&
    !$(".hero__slider.has-multiple").hasClass("slick-initialized")
  ) {
    $(".hero__slider.has-multiple").slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 2000,
      fade: true,
      cssEase: "linear",
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      pauseOnFocus: false,
    });
  }

  if ($(".photo-slideshow__inner").length && !$(".photo-slideshow__inner").hasClass("slick-initialized")) {
    $(".photo-slideshow__inner").slick({
      infinite: true,
      speed: 2000,
	  arrows: false,
      cssEase: "ease-in-out",
	  slidesToShow: 4,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      pauseOnFocus: false,
	  responsive: [
		{
			breakpoint: 1200,
			settings: {
				slidesToShow: 3,
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
			}
		}
	  ]
    });
  }

  if ($(".newsfeed__slider").length && !$(".newsfeed__slider").hasClass("slick-initialized")) {
	$(".newsfeed__slider").on("reInit.positionNewsfeedArrows setPosition.positionNewsfeedArrows", function() {
	  positionNewsfeedArrows();
	});

	$(".newsfeed__slider").slick({
	  infinite: true,
	  speed: 2000,
	  arrows: true,
	  appendArrows: $(".newsfeed__arrows"),
	  cssEase: "ease-in-out",
	  slidesToShow: 3,
	  autoplay: true,
	  autoplaySpeed: 5000,
	  pauseOnHover: false,
	  pauseOnFocus: false,
	  responsive: [
		{
		  breakpoint: 1200,
		  settings: {
			slidesToShow: 3,
		  },
		},
		{
		  breakpoint: 830,
		  settings: {
			slidesToShow: 2,
		  },
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
			},
		}
	  ],
	});
  }	

  // Arrows placement
  function positionNewsfeedArrows() {
	let $newsfeedArrows = $(".newsfeed__arrows");
	let $newsfeedWrapper = $(".newsfeed__wrapper");
	if ($(window).width() > vector.breakpoints.md) {
		// Get the height of the newsfeed wrapper
		let wrapperHeight = $newsfeedWrapper.outerHeight();
		// Set margin-top of the arrows to be the wrapper height + 24px (to account for spacing)
		$newsfeedArrows.css("margin-top", wrapperHeight + 48 + "px");
	} else {
		$newsfeedArrows.css("margin-top", "24px");
	}
  }

  positionNewsfeedArrows();
  $(window).on("resize", function() {
    positionNewsfeedArrows();
  });
	
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/home.js